import { useEffect } from 'react';
import { rage, useObservable } from '~/rage';
import { VehicleConsumableGroup } from '~/shared';
import breaks from '../../assets/images/break.svg';
import engine from '../../assets/images/engine.svg';
import oil from '../../assets/images/oil.svg';
import tires from '../../assets/images/tires.svg';
import transmission from '../../assets/images/transmission.svg';
import {
	setDisplayedConsumablesHealth,
	setDisplayedEngineHealth,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { VehicleStateItem } from '../VehicleStateItem';
import { StyledContainer } from './VehicleState.styled';

const VehicleState = () => {
	const dispatch = useLayoutDispatch();

	const consumablesHealth = useObservable(
		rage.vehicleServiceStation.getConsumablesHealth(),
	);
	const engineHealth = useObservable(
		rage.vehicleServiceStation.getEngineHealth(),
	);

	const displayedEngineHealth = useLayoutSelector(
		(state) => state.vehicleService.displayedEngineHealth,
	);
	const displayedConsumablesHealth = useLayoutSelector(
		(state) => state.vehicleService.displayedConsumablesHealth,
	);

	useEffect(() => {
		dispatch(setDisplayedEngineHealth(engineHealth));
	}, [engineHealth]);

	useEffect(() => {
		dispatch(setDisplayedConsumablesHealth(consumablesHealth));
	}, [consumablesHealth]);

	const renderEngineHealth = displayedEngineHealth ?? engineHealth;
	const renderConsumablesHealth =
		displayedConsumablesHealth ?? consumablesHealth;

	return (
		<StyledContainer>
			<VehicleStateItem
				name={'Состояние двигателя'}
				percent={renderEngineHealth}
				icon={engine}
			/>
			<VehicleStateItem
				name={'Моторное масло'}
				percent={renderConsumablesHealth[VehicleConsumableGroup.MOTOR_OIL] ?? 0}
				icon={oil}
			/>
			<VehicleStateItem
				name={'Масло КПП'}
				percent={
					renderConsumablesHealth[VehicleConsumableGroup.TRANSMISSION_OIL] ?? 0
				}
				icon={transmission}
			/>
			<VehicleStateItem
				name={'Состояние колодок'}
				percent={
					renderConsumablesHealth[VehicleConsumableGroup.BRAKE_PADS] ?? 0
				}
				icon={breaks}
			/>
			<VehicleStateItem
				name={'Остаток протектора шин'}
				percent={renderConsumablesHealth[VehicleConsumableGroup.TIRES] ?? 0}
				icon={tires}
			/>
		</StyledContainer>
	);
};

export { VehicleState };
